<template>
    <v-layout justify-center align-center class="w-100 h-100">
        <v-img :aspect-ratio="166 / 36" width="166" height="36" max-width="166" contain :src="company.logo?.src">
            <v-fade-transition>
                <v-overlay v-if="!company.logo?.src" absolute light color="white">
                    <image-overlay>{{ company.name }}</image-overlay>
                </v-overlay>
            </v-fade-transition>
        </v-img>
    </v-layout>
</template>

<script>
import { initEmploymentContract } from "@/assets/variables";
import ImageOverlay from "@/components/dumb/image-overlay.vue";

export default {
    components: {
        ImageOverlay,
    },
    props: {
        value: { type: Object, default: initEmploymentContract },
    },
    computed: {
        company() {
            return this.value.company;
        },
    },
};
</script>

<style></style>
